import country from './tourCriteria/country';
import resorts from './tourCriteria/resorts';
import checkInDateRange from './tourCriteria/checkInDateRange';
import nightRange from './tourCriteria/nightRange';
import touristGroup from './tourCriteria/touristGroup';
import hotels from './tourCriteria/hotels';
// import priceRange from './tourCriteria/priceRange';

export default (tourCriteria) => {
    const tourCriteriaJson = {
        ...country(tourCriteria),
        ...checkInDateRange(tourCriteria),
        ...nightRange(tourCriteria),
        ...touristGroup(tourCriteria),
        ...hotels(tourCriteria),
        ...resorts(tourCriteria),
        // ...priceRange(tourCriteria), // вырезано для hotel offer т.к сильно режет выдачу
    };

    return tourCriteriaJson;
};